var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { v4 as uuid } from "uuid";
import { uploadFile, validateFile } from "../file-upload-utils/fileUploadUtil";
import { FileUploadContext } from "../file-upload-utils/useFileUploadContext";
import { FileUploadManagerButton, FileUploadManagerSubmit, } from "../file-upload-utils/styled-components/StyledFileUpload";
export const FileUploadManager = ({ authToken, children, contentTypes, maxFileSizeInMegaBytes, objectId, objectType, onFileValidated, onFilesChanged, onUploadFinished, stage, uploadImmediately = false, }) => {
    const [filesWaiting, setFilesWaiting] = useState({});
    const handleValidateFiles = (files) => [...files].filter((file) => {
        const validateFileResult = validateFile({
            file,
            contentTypes,
            maxFileSizeInMegaBytes,
        });
        onFileValidated(validateFileResult);
        return validateFileResult.isValid;
    });
    const handleRemoveFile = (internalId) => {
        setFilesWaiting((prevFilesWaiting) => {
            const _a = prevFilesWaiting, _b = internalId, fileToRemove = _a[_b], filesToKeep = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return filesToKeep;
        });
    };
    const handleUploadFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
        const uploadFileResult = yield uploadFile({
            stage,
            authToken,
            file,
            objectId,
            objectType,
        });
        onUploadFinished(uploadFileResult);
        return uploadFileResult;
    });
    const handleOnChange = ({ target: { files }, }) => __awaiter(void 0, void 0, void 0, function* () {
        if (files !== null && files[0] !== undefined) {
            onFilesChanged(files);
            const validatedFiles = handleValidateFiles(files);
            if (uploadImmediately) {
                yield Promise.all(validatedFiles.map((file) => handleUploadFile(file)));
                return;
            }
            setFilesWaiting(Object.fromEntries(validatedFiles.map((file) => [uuid(), file])));
        }
    });
    const providerValue = useMemo(() => ({
        contentTypes,
        filesWaiting,
        maxFileSizeInMegaBytes,
        handleOnChange,
        handleRemoveFile,
        handleUploadFile,
        uploadImmediately,
    }), [contentTypes, filesWaiting, maxFileSizeInMegaBytes, uploadImmediately]);
    return (_jsx(FileUploadContext.Provider, Object.assign({ value: providerValue }, { children: children })));
};
FileUploadManager.Button = FileUploadManagerButton;
FileUploadManager.Submit = FileUploadManagerSubmit;
